import React from 'react';
import MainLayout from '../../layouts/MainLayout';

export const ETools = () => {
  return <MainLayout></MainLayout>;
};
